.home {
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-lg);
  text-align: center;
}

.home h1 {
  font-size: var(--font-size-xl);
  color: var(--text-primary);
  margin-bottom: var(--spacing-md);
}

.home p {
  font-size: var(--font-size-md);
  color: var(--text-secondary);
  line-height: 1.6;
}
